module.exports = {
	"id": "LU",
	"name": "Luxembourg",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.01333,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.033325,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01333,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.019995,
			"32": 0.019995,
			"33": null,
			"34": 0.01333,
			"35": 0.01333,
			"36": 0.019995,
			"37": 0.019995,
			"38": 0.02666,
			"39": 0.113305,
			"40": 0.01333,
			"41": 0.019995,
			"42": 0.019995,
			"43": 0.17329,
			"44": 0.03999,
			"45": 0.113305,
			"46": 0.03999,
			"47": 0.126635,
			"48": 0.2666,
			"49": 1.073065,
			"50": 0.139965,
			"51": 0.65317,
			"52": 0.47988,
			"53": 17.43564,
			"54": 3.979005,
			"55": 0.059985,
			"56": 0.033325,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006665,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.01333,
			"13": null,
			"14": null,
			"15": 0.006665,
			"16": 0.03999,
			"17": null,
			"18": 0.01333,
			"19": null,
			"20": null,
			"21": 0.01333,
			"22": null,
			"23": null,
			"24": 0.019995,
			"25": 0.006665,
			"26": null,
			"27": 0.006665,
			"28": 0.01333,
			"29": 0.02666,
			"30": 0.019995,
			"31": 0.219945,
			"32": 0.01333,
			"33": 0.02666,
			"34": 0.01333,
			"35": 0.033325,
			"36": 0.019995,
			"37": 0.02666,
			"38": 0.406565,
			"39": 0.05332,
			"40": 0.05332,
			"41": 0.03999,
			"42": 0.09331,
			"43": 0.17329,
			"44": 0.073315,
			"45": 0.753145,
			"46": 0.139965,
			"47": 0.793135,
			"48": 1.046405,
			"49": 10.94393,
			"50": 0.07998,
			"51": 0.02666,
			"52": null,
			"3.5": null,
			"3.6": 0.019995
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.01333,
			"37": 0.006665,
			"38": 0.073315,
			"39": 0.03999,
			"40": 0.42656,
			"41": 0.073315,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.05332
		},
		"safari": {
			"0": null,
			"4": 0.03999,
			"5": 0.06665,
			"6": 0.01333,
			"7": 0.06665,
			"8": 0.38657,
			"9": 0.54653,
			"10": 3.672415,
			"3.1": null,
			"3.2": null,
			"5.1": 0.353245,
			"6.1": 0.22661,
			"7.1": 0.01333,
			"9.1": 2.752645
		},
		"ios_saf": {
			"8": 0,
			"10": 11.2496058684,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.303163860949,
			"8.1-8.4": 0.560082387177,
			"9.0-9.2": 0.267195267277,
			"9.3": 4.07644061615
		},
		"android": {
			"3": 0,
			"4": 0.014240496124,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0017800620155,
			"4.1": 0.051367503876,
			"4.2-4.3": 0.12841875969,
			"4.4": 0.294473116279,
			"4.4.3-4.4.4": 0.297016062016
		},
		"ie": {
			"6": 0.831153128904,
			"7": 0.026811391255,
			"8": 2.88892740772,
			"9": 0.308330999432,
			"10": 0.315033847246,
			"11": 7.43345822544,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0223157602965,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000619882230459
		},
		"edge": {
			"12": 0.086645,
			"13": 0.69316,
			"14": 2.19945
		},
		"ie_mob": {
			"10": 0.0499930140845,
			"11": 0.203542985915
		},
		"bb": {
			"7": 0.010008,
			"10": null
		},
		"samsung": {
			"0": 4.610352
		},
		"and_uc": {
			"0": 0.447024
		},
		"op_mini": {
			"0": 0.300656357473
		},
		"and_chr": {
			"0": 10.994539
		},
		"and_ff": {
			"0": 0.06672
		}
	},
	"total": 97.76693
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LU.json
 ** module id = 579
 ** module chunks = 0
 **/